import { useState } from "react";
import { Button } from "../ui/button";
import { Eye, FilePdf, EnvelopeSimple } from "@phosphor-icons/react";
import { downloadAuthFile } from "../../lib/fileOpen";
import QuoteDrawer from "./QuoteDrawer";
import QuoteEmailDialog from "./QuoteEmailDialog";

/* Inline actions for a quote surfaced on a request / job page: preview in a drawer, download the client PDF, email it. */
export default function QuoteQuickActions({ quoteId, reference, onChanged, testId = "quote-quick" }) {
  const [open, setOpen] = useState(false);
  const [emailOpen, setEmailOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!quoteId) return null;
  const pdf = async (e) => {
    e.stopPropagation();
    setBusy(true);
    await downloadAuthFile(`/quotes/${quoteId}/pdf?view=client`, `${reference || "quote"}_client.pdf`);
    setBusy(false);
  };
  return (
    <div className="inline-flex items-center gap-1" data-testid={`${testId}-actions`} onClick={(e) => e.stopPropagation()}>
      <Button size="sm" variant="outline" className="h-7 text-xs" onClick={() => setOpen(true)} data-testid={`${testId}-view`}><Eye size={13} className="mr-1" /> View quote</Button>
      <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={pdf} disabled={busy} title="Download client PDF" data-testid={`${testId}-pdf`}><FilePdf size={13} className="mr-1" /> PDF</Button>
      <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={() => setEmailOpen(true)} title="Email quote to client" data-testid={`${testId}-email`}><EnvelopeSimple size={13} className="mr-1" /> Email</Button>
      <QuoteDrawer quoteId={quoteId} open={open} onOpenChange={setOpen} onChanged={onChanged} />
      <QuoteEmailDialog quoteId={quoteId} open={emailOpen} onOpenChange={setEmailOpen} onSent={onChanged} />
    </div>
  );
}
